import { Application } from '@hotwired/stimulus';
import AddressForm from './section-p/address-form';
import { SimpleLoginController } from './login/simple-login.stimulus';
import { shouldLoad as shouldSiteHeaderAltLoad } from './site-headers/site-header-alt-loader';
import { shouldLoad as shouldMyContentItemGroupsLoad } from './section-m/my-content-item-groups-loader';

export default async function init(application: Application) {
    AddressForm();

    SimpleLoginController.register(application);

    if (shouldSiteHeaderAltLoad()) {
        const { SiteHeaderAltController } = await import('./site-headers/site-header-alt.stimulus');
        SiteHeaderAltController.register(application);
    }

    if (shouldMyContentItemGroupsLoad()) {
        const { MyContentItemGroupsController } = await import('./section-m/my-content-item-groups.stimulus');
        MyContentItemGroupsController.register(application);
    }
}
